// Spinner.js
import React from 'react';

const NPSpinner = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: '100vh' }}
    >
      <div
        className="spinner-border"
        style={{ width: '4.5rem', height: '4.5rem', borderWidth: '0.75rem' }}
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default NPSpinner;
